










































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { Getter } from "vuex-class";
import Button from "@/components/Button.vue";
import Question from "@/components/Question.vue";
import Logo from "@/components/Logo.vue";
import ArrowLeftIcon from "@/assets/icons/ArrowLeftIcon.vue";
import Message from "@/components/Message.vue";
import { Department, User } from "../interfaces";

enum Status {
  answering = "ANSWERING",
  submitting = "SUBMITTING",
  submitted = "SUBMITTED",
}

type Target = { value: string; id: string } | null;

@Component({
  components: {
    appLogo: Logo,
    appArrowLeftIcon: ArrowLeftIcon,
    appQuestion: Question,
    appButton: Button,
    appMessage: Message,
  },
})
export default class Form extends Vue {
  @Prop({ default: null }) readonly formId?: string;
  @Getter("userIsInMultipleDepartments", { namespace: "auth" })
  userIsInMultipleDepartments!: boolean;
  @Getter("user", { namespace: "auth" }) user!: User;
  @Getter("departments") departments!: Department[];

  form: any = null;
  answers = {};
  target: Target = null;
  targetOptions = [];
  status = Status.answering;
  isErrorMessageOpen = false;
  error = "";
  selectedDepartment: { id: string; value: string } | null = null;
  departmentOptions: { id: string; value: string }[] = [];

  @Watch("target", { deep: true })
  onTargetChange(newTarget: Target, oldTarget: Target) {
    if (this.form?.tool.name === "Régua de Desempenho") {
      const managers = this.departments.find(
        (department) => this.selectedDepartment?.id === department._id
      )?.manager;

      if (
        oldTarget &&
        newTarget &&
        managers?.includes(oldTarget.id) !== managers?.includes(newTarget.id)
      ) {
        this.answers = {};
      }
    }
  }

  @Watch("selectedDepartment", { deep: true })
  onSelectedDepartmentChange() {
    this.axios
      .get(`/api/forms/${this.formId}/targets/${this.selectedDepartment?.id}`)
      .then(({ data }) => (this.targetOptions = data.targets))
      .catch((error) => console.log(error));

    this.axios
      .get(`/api/forms/${this.formId}/${this.selectedDepartment?.id}`)
      .then(({ data }) => (this.form = data.form))
      .catch((error) => console.log(error));
  }

  @Watch("form", { deep: true })
  onFormChange() {
    this.answers = {};
  }

  @Watch("targets", { deep: true })
  onTargetsChange() {
    if (this.targets.length > 0) {
      this.target = this.targets[0];
    } else {
      this.target = null;
    }
  }

  get targets() {
    return this.targetOptions.map(
      (target: { firstName: string; lastName: string; _id: string }) => ({
        id: target._id,
        value: `${target.firstName} ${target.lastName}`,
      })
    );
  }

  get questions() {
    if (!this.form) {
      return [];
    } else if (this.form.tool.name === "Régua de Desempenho") {
      if (!this.target) {
        return [];
      } else if (
        this.departments
          .find((department) => this.selectedDepartment?.id === department._id)
          ?.manager.includes(this.target.id)
      ) {
        return this.form.questions.filter(
          (question: { question: { target: string } }) =>
            question.question.target === "manager"
        );
      } else {
        return this.form.questions.filter(
          (question: { question: { target: string } }) =>
            question.question.target === "team"
        );
      }
    } else if (this.form.tool.name === "AV360") {
      if (!this.target) {
        return [];
      }
    }
    return this.form.questions;
  }

  mounted() {
    this.departmentOptions = this.departments
      .map(({ _id, name }) => ({ id: _id, value: name }))
      .filter((department) => this.user.department.includes(department.id));

    this.selectedDepartment =
      this.departmentOptions.find(
        (department) => department.id === this.user.department[0]
      ) ?? null;
  }

  onSubmit() {
    this.status = Status.submitting;
    const answers = Object.entries(this.answers);
    const formAnswer = {
      form: this.formId,
      ...(this.target && { targetUser: this.target.id }),
      department: this.selectedDepartment?.id,
      answer: answers.map((answer) => {
        return {
          question: answer[0],
          ...(typeof answer[1] === "string" && { textAnswer: answer[1] }),
          ...(answer[1] instanceof Array && { selectedOptions: answer[1] }),
        };
      }),
    };
    formAnswer.answer = formAnswer.answer.filter(
      (answer) =>
        (answer.selectedOptions && answer.selectedOptions.length > 0) ||
        answer.textAnswer
    );
    this.axios
      .post("/api/answers", formAnswer)
      .then((response) => {
        this.status = Status.submitted;
        response;
      })
      .catch((error) => {
        this.status = Status.answering;
        this.isErrorMessageOpen = true;
        this.error = error.response.data.error;
        error.response;
      });
  }
}
